import React from "react";
import routes from "package-common-react/lib/routes";

import Logo from "../../components/Logo";
import logoQuiz from "../../images/logo-quiz-vacances.png";

import {
  Layout,
  Header,
  Headline,
  HomeLink,
  ImageLogo,
  Main,
  Footer,
  LegalButton
} from "./style";

import LegalInformations from "../../components/LegalInformations";
import GamesLinks from "../../components/GamesLinks";

export default function PreHome() {
  return (
    <Layout>
      <Header>
        <Headline>
          Cet été, jouez
          <small>avec PIÈCES&nbsp;AUTO !</small>
        </Headline>
      </Header>
      <Main>
        <HomeLink to={routes.home.path}>
          <ImageLogo
            src={logoQuiz}
            alt="Quiz Cahier de Vacances"
            width="1486"
            height="1151"
          />
        </HomeLink>
        <GamesLinks size={100} />
      </Main>
      <Footer>
        <LegalButton>
          {({ state, hide }) => (
            <LegalInformations isHome state={state} hide={hide} />
          )}
        </LegalButton>
        <Logo isHome />
      </Footer>
    </Layout>
  );
}



// WEBPACK FOOTER //
// ./src/pages/PreHome/index.js